/* Utils */
import {
  STORAGE_COUNTRY,
  DEFAULT_COUNTRY_USER,
} from './constants';
import { featureFlagParentalControl } from './profiles';

export default function parentalControlBlock(content) {
  const country = localStorage.getItem(STORAGE_COUNTRY) || DEFAULT_COUNTRY_USER;
  const hasParentalControlAllowed = featureFlagParentalControl(country);

  if (!hasParentalControlAllowed) {
    return false;
  }

  const contentRating = content?.rating;
  const ageRating = JSON.parse(localStorage.getItem('profile'))?.ageRating;
  const isNotRatedContentAllowed = JSON.parse(localStorage.getItem('profile'))?.isNotRatedContentAllowed;

  const ageRatingNumber = ratingToNumber(ageRating);
  const contentRatingNumber = ratingToNumber(contentRating);

  if (ageRatingNumber === undefined) {
    return false;
  }

  if (contentRatingNumber === undefined) {
    // eslint-disable-next-line eqeqeq -- we need to check both null and undefined
    return isNotRatedContentAllowed == undefined ? false : !isNotRatedContentAllowed;
  }

  return ageRatingNumber < contentRatingNumber;
}

function ratingToNumber(value) {
  let rating = value;

  if (rating === 'L' || rating === 'AL') {
    return 0;
  }

  if ((/\d+/g).test(rating)) {
    if (typeof rating === 'string') {
      rating = rating.match(/\d+/g);
    }
    return Number(rating);
  }

  return undefined;
}
